import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IssuedBooksModel } from 'data/library/issueBook/issueBook.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: IssuedBooksModel[];
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: [],
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<IssuedBooksModel[]>> = (_, action) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: [],
  status: 'error',
});

const IssuedBooksSlice = createSlice({
  name: 'IssuedBooks',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default IssuedBooksSlice;
